<template>
  <div>
    <video-player
      v-show="isShowCar1"
      class="bg"
      ref="videoPlayerbg1"
      :options="playerOptionsBG1"
      :playsinline="true"
      @click="OnShake"
    ></video-player>
    <video-player
      v-show="isShowCar2"
      class="bg"
      ref="videoPlayerbg2"
      :options="playerOptionsBG2"
      :playsinline="true"
      @click="OnShake"
    ></video-player>
    <video-player
      v-show="isShowCar3"
      class="bg"
      ref="videoPlayerbg3"
      :options="playerOptionsBG3"
      :playsinline="true"
      @click="OnShake"
    ></video-player>
    <!--<img class="bg" src="../assets/行走BAR/行走BAR_preview.png" />-->
    <img v-show="isShowCar1" class="profile_frame" src="../assets/行走BAR/Circle_Y.png" />
    <img v-show="isShowCar2" class="profile_frame" src="../assets/行走BAR/Circle_B.png" />
    <img v-show="isShowCar3" class="profile_frame" src="../assets/行走BAR/Circle_R.png" />
    <img v-if="Player.pictureUrl" class="profile" :src="`${host}/${Player.pictureUrl}`" />
    <img @click="OnShake" class="tipbtn" src="../assets/行走BAR/行走BAR.png" />
    <p class="sn">{{ this.carLabel + String(this.Player.serialNumber % 10000).padStart(4,'0') }}</p>
    <div class="shakebtn" @click="OnShake"></div>
    <img class="speed" src="../assets/1.行走/speed_BG.png" />
    <img ref="speedbar" class="speedbar" src="../assets/1.行走/speed_pointer.png" />
  </div>
</template>
<script>
import DataServices from "../services/DataService";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
export default {
  components: {
    videoPlayer
  },
  mounted() {
    this.host = process.env.VUE_APP_BASEURL;
    this.shakeTime = new Date().getTime();
    this.CheckTime();
  },
  methods: {
    CheckTime() {
      var _this = this;
      setTimeout(() => {
        var curTime = new Date().getTime();
        var diffTime = curTime - _this.shakeTime;
        if (_this.isStarting && !_this.isStoping && diffTime > 2000) {
          _this.isStoping = true;
          _this.$refs.speedbar.classList.add("stoping");
          _this.$refs.speedbar.classList.remove("playing");
          setTimeout(() => {
            _this.$refs.speedbar.classList.add("idle");
            _this.$refs.speedbar.classList.remove("stoping");
            _this.isStoping = false;
            _this.isStarting = false;
          }, 700);
        }
        _this.CheckTime();
      }, 300);
    },
    OnSetCarIndex(player) {
      this.Player.carType = player.carType;
      this.Player.serialNumber = player.serialNumber;
      var index = this.Player.carType;
      if (index == 1) {
        this.carLabel = "C&C";
        this.isShowCar1 = true;
      } else if (index == 2) {
        this.carLabel = "FIN";
        this.isShowCar2 = true;
      } else {
        this.carLabel = "黑松";
        this.isShowCar3 = true;
      }
      this.$refs.speedbar.classList.add("idle");
    },
    OnShake() {
      this.shakeTime = new Date().getTime();
      if (!this.isStarting) {
        this.isStarting = true;
        this.$refs.speedbar.classList.add("starting");
        this.$refs.speedbar.classList.remove("idle");
        var _this = this;
        setTimeout(() => {
          _this.$refs.speedbar.classList.add("playing");
          _this.$refs.speedbar.classList.remove("starting");
        }, 700);
      }
      DataServices.Shake({
        id: this.Player.id
      });
    }
  },
  props: {
    Player: {
      id: "",
      carType: 1
    }
  },
  data() {
    return {
      carLabel: "C&C",
      isStoping: false,
      isStarting: false,
      isShowCar1: false,
      isShowCar2: false,
      isShowCar3: false,
      shakeTime: 0,
      host: "",
      playerOptionsBG1: {
        muted: true,
        aspectRatio: "9:16",
        inactivityTimeout: 0,
        autoplay: true,
        controls: false,
        loop: true,
        sources: [
          {
            type: "video/mp4",
            src:
              "https://downloadapp.blob.core.windows.net/data/heysong/Car_1.mp4"
          }
        ],
        controlBar: {
          fullscreenToggle: false,
          durationDisplay: false,
          progressControl: false,
          remainingTimeDisplay: false,
          volumeMenuButton: false,
          volumePanel: false
        }
      },
      playerOptionsBG2: {
        muted: true,
        aspectRatio: "9:16",
        inactivityTimeout: 0,
        autoplay: true,
        controls: false,
        loop: true,
        sources: [
          {
            type: "video/mp4",
            src:
              "https://downloadapp.blob.core.windows.net/data/heysong/Car_2.mp4"
          }
        ],
        controlBar: {
          fullscreenToggle: false,
          durationDisplay: false,
          progressControl: false,
          remainingTimeDisplay: false,
          volumeMenuButton: false,
          volumePanel: false
        }
      },
      playerOptionsBG3: {
        muted: true,
        aspectRatio: "9:16",
        inactivityTimeout: 0,
        autoplay: true,
        controls: false,
        loop: true,
        sources: [
          {
            type: "video/mp4",
            src:
              "https://downloadapp.blob.core.windows.net/data/heysong/Car_3.mp4"
          }
        ],
        controlBar: {
          fullscreenToggle: false,
          durationDisplay: false,
          progressControl: false,
          remainingTimeDisplay: false,
          volumeMenuButton: false,
          volumePanel: false
        }
      }
    };
  }
};
</script>
<style scoped>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100vw;
  max-width: 100vw;
}
.tipbtn {
  position: absolute;
  top: 13vw;
  left: -1vw;
  width: 47vw;
  z-index: 1;
}
.speed {
  position: absolute;
  top: 50vw;
  left: 25vw;
  width: 50vw;
  z-index: 1;
}
.speedbar {
  height: 15vw;
  left: 46.2vw;
  position: absolute;
  top: 57vw;
  transform-origin: 50% 90%;
  z-index: 2;
}
.speedbar.idle {
  animation: idle 0.1s infinite reverse;
}
.speedbar.playing {
  animation: playing 0.1s infinite reverse;
}
.speedbar.starting {
  animation: starting 0.7s;
}
.speedbar.stoping {
  animation: stoping 0.7s;
}
@keyframes idle {
  from {
    transform: rotateZ(-122deg);
  }
  to {
    transform: rotateZ(-118deg);
  }
}
@keyframes starting {
  from {
    transform: rotateZ(-120deg);
  }
  to {
    transform: rotateZ(120deg);
  }
}
@keyframes stoping {
  from {
    transform: rotateZ(120deg);
  }
  to {
    transform: rotateZ(-120deg);
  }
}
@keyframes playing {
  from {
    transform: rotateZ(118deg);
  }
  to {
    transform: rotateZ(122deg);
  }
}
@keyframes rotate {
  100% {
    transform: rotateZ(360deg);
  }
}
.profile_frame {
  position: absolute;
  top: 26vw;
  left: 0vw;
  width: 14vw;
  z-index: 2;
}
.profile {
  position: absolute;
  top: 26.2vw;
  left: 0.2vw;
  width: 14vw;
  z-index: 2;
  clip-path: circle(5.3vw at center);
}
.shakebtn {
  position: absolute;
  top: 0vw;
  left: 0vw;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.sn {
  position: absolute;
  color: black;
  font-size: 4.2vw;
  top: 27vw;
  left: 14vw;
  z-index: 3;
}
</style>
